import React from 'react'
import LoginForm from '../../../components/auth/Login'
import FormWrapper from '../../../layout/formLayout/FormWrapper'
import Header from '../../../components/form/Header'

export default function LoginPage() {
  return (
    <FormWrapper>
      <Header title="Login"/>
      <LoginForm category='students' redirect="/" />
    </FormWrapper>
  )
}
